module.exports = __webpack_public_path__ + "img/share.d542c474.png";